// Catálogo de motivos de devolución (SPEC_DEVOLUCIONES_v0.1.md RF2 en
// ventax-subs-api). El operador nunca ve el código SIFEN, solo la etiqueta.
// Compartido entre DevolucionModal.vue (selector) y NotasCreditoView.vue
// (columna "Motivo" del historial) para no duplicar el mapeo.
export const MOTIVOS_DEVOLUCION = [
  { value: 'DEVOLUCION_MERCADERIA', label: 'Devolución de mercadería' },
  { value: 'DESCUENTO', label: 'Descuento' },
  { value: 'DEVOLUCION_Y_DESCUENTO', label: 'Devolución de mercadería + descuento' },
  { value: 'ERROR_CARGA', label: 'Error de carga' }
]

export function motivoLabel(value) {
  return MOTIVOS_DEVOLUCION.find((m) => m.value === value)?.label || value || '—'
}
